const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5777";

export { API_BASE_URL };
